import { render } from "./PresentationGroupDetailVx.vue?vue&type=template&id=33061332"
import script from "./PresentationGroupDetailVx.vue?vue&type=script&lang=js"
export * from "./PresentationGroupDetailVx.vue?vue&type=script&lang=js"

import "./PresentationGroupDetailVx.vue?vue&type=style&index=0&id=33061332&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__